/* @flow */

import React, { useContext } from "react";

import { StoreInfoContext } from "entrypoint/shared";
import { useTranslate } from "@awardit/react-use-translate";
import Wrapper from "components/Wrapper";
import { ButtonLink } from "@crossroads/ui-components";
import PopularBrands from "components/PopularBrands";

import cn from "classnames";
import styles from "./styles.scss";

const InfoCard = ({ children, text }: { children: React$Node, text: string }): React$Node => {
  return (
    <div className={styles.infoCard}>
      <div className={styles.iconContainer}>{children}</div>
      <h3 className={styles.subHeading}>{text}</h3>
    </div>
  );
};

const CompanyView = (): React$Node => {
  const t = useTranslate();
  const { info } = useContext(StoreInfoContext);

  // Check if the locale is Swedish (sv_SE)
  const isSE = info.locale === "sv_SE";

  return (
    <div className={styles.block}>
      <Wrapper>
        <img className={styles.imageBanner} src="/assets/company/awardit-splash-img.jpeg" alt="" />
        <section className={cn(styles.center, styles.section)}>
          <h1 className={styles.heading}>{t("COMPANYVIEW.FIELD_1.TITLE")}</h1>
          <p>{t("COMPANYVIEW.FIELD_1.TEXT_CONTENT")}</p>
        </section>
        <img className={styles.imageBanner} src="/assets/company/zupergift-smile-card.jpg" alt="" />
        <section className={cn(styles.center, styles.section)}>
          <h2 className={styles.heading}>{t("COMPANYVIEW.FIELD_2.TITLE")}</h2>
          <p>{t("COMPANYVIEW.FIELD_2.TEXT_CONTENT")}</p>
          <div className={styles.ctaField}>
            <ButtonLink
              variant="secondary"
              className={styles.cta}
              to={t("COMPANYVIEW.CTA_LINK_1")}
              target="_blank"
            >
              {t("COMPANYVIEW.CTA_1")}
            </ButtonLink>
          </div>
        </section>
        <section className={cn(styles.split, styles.section)}>
          <div className={styles.imageWrapper}>
            <img className={styles.imageSplit} src="/assets/company/phone-zupergift.png" alt="" />
          </div>
          <div className={styles.textSplit}>
            <h2 className={styles.heading}>{t("COMPANYVIEW.FIELD_3.TITLE")}</h2>
            <p>{t("COMPANYVIEW.FIELD_3.TEXT_CONTENT")}</p>
          </div>
        </section>
        <section className={cn(styles.popularBrands, styles.section)}>
          <PopularBrands variant="alt-heading" />
        </section>
        {isSE ? (
          <>
            <section className={cn(styles.split, styles.section)}>
              <div className={cn(styles.textSplit, styles.typography)}>
                <h2 className={styles.heading}>{t("COMPANYVIEW.FIELD_4.TITLE")}</h2>
                <p>{t("COMPANYVIEW.FIELD_4.TEXT_CONTENT")}</p>
                <div className={styles.list}>
                  <ul>
                    <li>{t("COMPANYVIEW.FIELD_4.LIST_ITEM_1")}</li>
                    <li>{t("COMPANYVIEW.FIELD_4.LIST_ITEM_2")}</li>
                    <li>{t("COMPANYVIEW.FIELD_4.LIST_ITEM_3")}</li>
                    <li>{t("COMPANYVIEW.FIELD_4.LIST_ITEM_4")}</li>
                  </ul>
                </div>
              </div>
              <div className={styles.imageWrapper}>
                <img className={styles.imageSplit} src="/assets/company/laptop-awardit.png" alt="" />
              </div>
            </section>
            <section className={cn(styles.center, styles.section)}>
              <div className={styles.ctaField}>
                <ButtonLink
                  variant="primary"
                  className={styles.cta}
                  to="https://awarditrewards.se/"
                  target="_blank"
                >
                  {t("COMPANYVIEW.CTA_2")}
                </ButtonLink>
                <span>{t("COMMON.OR")}</span>
                <ButtonLink
                  variant="secondary"
                  className={styles.cta}
                  to="https://share-eu1.hsforms.com/2QJ6B_Om_TlGIl9KKbMikpQ2dd4ic"
                  target="_blank"
                >
                  {t("COMPANYVIEW.CTA_3")}
                </ButtonLink>
              </div>
            </section>
            <section className={cn(styles.section)}>
              <h2 className={cn(styles.heading, styles.center)}>{t("COMPANYVIEW.FIELD_5.TITLE")}</h2>
              <div className={styles.grid}>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_1")}>
                  <img src="/assets/company/svg/vector_home.svg" alt="" />
                </InfoCard>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_2")}>
                  <img src="/assets/company/svg/vector_group.svg" alt="" />
                </InfoCard>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_3")}>
                  <img src="/assets/company/svg/vector_card.svg" alt="" />
                </InfoCard>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_4")}>
                  <img src="/assets/company/svg/vector_currency.svg" alt="" />
                </InfoCard>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_5")}>
                  <img src="/assets/tutorial/2.png" alt="" />
                </InfoCard>
                <InfoCard text={t("COMPANYVIEW.FIELD_5.LIST_ITEM_6")}>
                  <img src="/assets/company/svg/vector_graph.svg" alt="" />
                </InfoCard>
              </div>
            </section>
          </>
        ) : null}
      </Wrapper>
    </div>
  );
};

export default CompanyView;
